export default "__VITE_ASSET__SrilGzKW__"